import { isImage } from "./isImage";
import { isVideo } from "./isVideo";

export const isLegalMediaType = (type: string): boolean => isVideo(type) || isImage(type);
